import { Pipe, PipeTransform } from '@angular/core';
import * as Humanize from 'humanize-plus';

@Pipe({
  name: 'bytes',
  standalone: false,
})
export class BytesPipe implements PipeTransform {
  transform(size: any): any {
    if (!size || isNaN(size)) {
      return;
    }

    return Humanize.fileSize(size);
  }
}
